module.exports = __webpack_public_path__ + "src/asset/svg/title/history1.svg?68c0155738ac48a06eb774706ab1884b";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/title/history1.svg
// module id = 98
// module chunks = 0